class UploadAdapter {
  constructor(loader, uploadFile, editor) {
    this.loader = loader;
    this.uploadFile = uploadFile;
    this.abortController = new AbortController(); // For request cancellation
    this.editor = editor;
  }

  async upload() {
    const file = await this.loader.file;

    if (!file) {
      return Promise.reject("No file found");
    }

    return new Promise(async (resolve, reject) => {
      try {
        const response = await this.uploadFile({
          file,
          acl: "public-read",
          signal: this.abortController.signal,
          onUploadProgress: (progressEvent) => {
            if (progressEvent.total) {
              this.loader.uploadTotal = progressEvent.total; // Total file size
              this.loader.uploaded = progressEvent.loaded;   // Uploaded bytes
            }
          },
        }).unwrap();

        resolve({ default: response });

        // Move cursor to a new paragraph after the image
        setTimeout(() => {
          const model = this.editor.model;
          model.change((writer) => {
            const selection = model.document.selection;
            const position = selection.getLastPosition();
        
            // Create a new paragraph
            const paragraph = writer.createElement('paragraph');
        
            // Insert the paragraph after the uploaded image
            writer.insert(paragraph, position.root, 'end');
        
            // Move the cursor inside the new paragraph
            writer.setSelection(paragraph, 'in');
          });
        }, 100);
      } catch (error) {
        if (error.name === "AbortError") {
          reject("Upload aborted");
        } else {
          reject(error);
        }
      }
    });
  }

  abort() {
    if (this.abortController) {
      this.abortController.abort(); // Cancel request
    }
  }
}

export default UploadAdapter;